import { map } from "rxjs/operators";
import { GET } from "../../../module/services/fetch";

export const getTaskBadge = () => {
  return GET("task/count").pipe(map((res: any) => res));
};

export const getApprovalBadge = () => {
  return GET("approvals/count", {}, {}, "", "", "").pipe(
    map((res: any) => res)
  );
};

export const getNotifications = () => {
  return GET("users/messages").pipe(map((res: any) => res));
};
